/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuTab } from '@neutron/react';

interface IReusableToolbarProps {
  background?: string;
  justify?: string;
  shadow?: boolean;
}

export const ReusableToolbar = styled.div<IReusableToolbarProps>`
  background: ${({ background }) => background || 'transparent'};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: ${({ justify }) => justify};
  box-shadow: ${({ shadow }) =>
    shadow ? '0px 2px 4px rgba(25, 25, 25, 0.2)' : 'none'};
`;

export const TabGroup = styled(NeuTab)`
  & > a {
    height: 100%;
  }
`;

export const Tab = styled(NeuTab)`
  display: flex;
  align-items: center;
  font-size: 1rem !important;
  font-weight: bold !important;
  height: 100%;
  padding-left: 15px !important;
  padding-right: 15px !important;
  transition: height 0s linear !important;
`;
